// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfd15d66","455":"cc254c6b","977":"4b477b04"}[chunkId] + ".chunk.js";
};